import React, { useEffect, useRef, useState } from "react";
import "../../assets/css/RakshabandhanLoader.css";
import $ from "jquery";

function RakshabandhanLoader() {
  const canvasRef = useRef(null);
  const [title, setTitle] = useState("");

  useEffect(() => {
    const rakhiMessages = [
      "Happy Rakshabandhan",
      "A Bond of Love",
      "Celebrating Sibling Smiles",
      "Threads of Protection",
      "Rakhi Mubarak",
    ];
    const message =
      rakhiMessages[Math.floor(Math.random() * rakhiMessages.length)];
    let index = 0;

    $("body").css("overflow", "hidden");

    const typing = setInterval(() => {
      if (index < message.length) {
        setTitle((prev) => prev + message[index]);
        index += 1;
      } else {
        clearInterval(typing);
      }
    }, 95);

    return () => clearInterval(typing);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationFrame;
    let particles = [];
    const colors = ["#f59e0b", "#e11d48", "#7c3aed", "#fef3c7", "#16a34a"];

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    class Petal {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = -24;
        this.size = Math.random() * 8 + 5;
        this.speed = Math.random() * 1.6 + 0.8;
        this.swing = Math.random() * 1.8 + 0.4;
        this.angle = Math.random() * Math.PI * 2;
        this.color = colors[Math.floor(Math.random() * colors.length)];
      }

      update() {
        this.y += this.speed;
        this.angle += 0.03;
        this.x += Math.sin(this.angle) * this.swing;
      }

      draw() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.beginPath();
        ctx.ellipse(0, 0, this.size * 0.55, this.size, 0, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.globalAlpha = 0.78;
        ctx.fill();
        ctx.restore();
      }
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (particles.length < 85 && Math.random() < 0.42) {
        particles.push(new Petal());
      }

      particles.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      particles = particles.filter((particle) => particle.y < canvas.height + 36);
      animationFrame = requestAnimationFrame(animate);
    };

    resizeCanvas();
    animate();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <div className="rakhi-loader">
      <canvas ref={canvasRef} className="rakhi-petals" />

      <div className="rakhi-stage">
        <div className="rakhi-thread" aria-hidden="true">
          <span className="thread-line thread-left"></span>
          <span className="rakhi-disc">
            <span className="rakhi-ring"></span>
            <span className="rakhi-center"></span>
            {Array.from({ length: 16 }).map((_, index) => (
              <i key={index} style={{ transform: `rotate(${index * 22.5}deg)` }} />
            ))}
          </span>
          <span className="thread-line thread-right"></span>
        </div>

        <div className="rakhi-copy">
          <p className="rakhi-date">Rakshabandhan</p>
          <h1>{title}</h1>
          <p className="rakhi-line">Celebrating care, trust, and lifelong bonds</p>
        </div>
      </div>
    </div>
  );
}

export default RakshabandhanLoader;
